module.exports = __webpack_public_path__ + "img/product-img-five.06f98a23.png";